// Per-button explanatory text shown under a transition button (QA #39: removed as noise - the
// buttons are self-explanatory). Kept as an empty, typed map so a hint can be re-added for a
// specific transition only once its behaviour is confirmed against the workflow seed.
export const TRANSITION_READY_HINTS: Record<string, string> = {};
